// extracted by mini-css-extract-plugin
export default {"uploader":"app-shifts-ShiftBatch-Upload-module__HUhLXBsWqV4l0xcLOOgG","text":"app-shifts-ShiftBatch-Upload-module__FHntSBWzTPixcze4pn1N"};